"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticityTokenSelector = exports.moduleName = void 0;
/**
 * Constants
 * */
exports.moduleName = 'authenticityToken';
/**
 * Reducer
 * */
function reducer(state, action) {
    if (state === void 0) { state = ''; }
    var type = action.type;
    switch (type) {
        default:
            return state;
    }
}
exports.default = reducer;
/**
 * Selectors
 * */
var authenticityTokenSelector = function (state) { return state[exports.moduleName]; };
exports.authenticityTokenSelector = authenticityTokenSelector;
/**
 * Action Creators
 * */
